<template>
  <div class="quiz-summary">
    <div class="quiz-mark">
      <div class="quiz-point quiz-point--blue mr-2">
        {{result.time ? result.time : '0'}}
      </div>
      <div class="quiz-text aflex-1">
        Menit Waktu Pengerjaan
      </div>
    </div>

    <div class="quiz-mark">
      <div class="quiz-point quiz-point--green mr-2">
        {{result.correct ? result.correct : '0'}}
      </div>
      <div class="quiz-text aflex-1">
        Total Jawaban Benar
      </div>
    </div>

    <div class="quiz-mark">
      <div class="quiz-point quiz-point--yellow mr-2">
        {{result.wrong ? result.wrong : '0'}}
      </div>
      <div class="quiz-text aflex-1">
        Total Jawaban Salah
      </div>
    </div>

    <div class="quiz-mark">
      <div class="quiz-point quiz-point--orange mr-2">
        {{result.not_answered ? result.not_answered : '0'}}
      </div>
      <div class="quiz-text aflex-1">
        Total Soal Tidak Dijawab
      </div>
    </div>

    <!-- <b-row>
      <b-col md="3" class="mb-1">
        <div class="aalign-center"></div>
      </b-col>

      <b-col md="3" class="mb-1">
        <div class="aalign-center">
          <div class="quiz-point quiz-point--green mr-2">
            45
          </div>
          <div class="quiz-text aflex-1">
            Total Jawaban Benar
          </div>
        </div>
      </b-col>

      <b-col md="3" class="mb-1">
        <div class="aalign-center">
          <div class="quiz-point quiz-point--yellow mr-2">
            5
          </div>
          <div class="quiz-text aflex-1">
            Total Jawaban Salah
          </div>
        </div>
      </b-col>

      <b-col md="3" class="mb-1">
        <div class="aalign-center">
          <div class="quiz-point quiz-point--orange mr-2">
            0
          </div>
          <div class="quiz-text aflex-1">
            Total Soal Tidak Dijawab
          </div>
        </div>
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      default: {}
    }
  }
};
</script>

<style scoped>
.quiz-summary {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.quiz-mark {
  display: flex;
  align-items: center;
  align-items: center;

  margin: 11px;
}

.quiz-point {
  width: 29.2px;
  height: 29.2px;
  background: red;
  border-radius: 50%;
  padding: 5px;
  font-size: 14px;
  display: inline-block;
  color: white;
  text-align: center;
}

.quiz-point--blue {
  background-color: #009feb;
}

.quiz-point--green {
  background-color: #00cbae;
}

.quiz-point--yellow {
  background-color: #ff7e1f;
}

.quiz-point--orange {
  background-color: #ff4e4b;
}

@media only screen and (max-width: 768px) {
  .quiz-summary {
    justify-content: flex-start;
  }
}
</style>
